<script>
    import { onMount } from 'svelte';
    import { createProject } from "../../Participaid.svelte";
    import { createEventDispatcher } from 'svelte';
    import generateSlug from 'project-name-generator';
    import Reporter from "../../lib/error.js";
    import Util from "../../lib/util.js";
    import addDate from 'date-fns/add';
    import { allTemplateFields } from "../../Participaid.svelte";
    import Project from "../../models/participaid/Project.js";
    import ProjectField from "../../models/participaid/ProjectField.js";

    import Dialog from "../Dialog.svelte";
    import ConfigureContributorDialog from "./ConfigureContributorDialog.svelte";
    import Overlay from "../Overlay.svelte";
    import NewProjectButton from "../NewProjectButton.svelte";
    import Name from "../Name.svelte";
    import CompanyDropdownCreator from "../form/CompanyDropdownCreator.svelte";
    import CloudinaryImageUpload from "../form/CloudinaryImageUpload.svelte";
    import Emoji from "../Emoji.svelte";
    import Field from "../form/Field.svelte";
    import TextField from "../form/TextField.svelte";
    import NumberField from "../form/NumberField.svelte";
    import Button from "../form/Button.svelte";
    import LoadingModal from "../LoadingModal.svelte";
    import Messages from "../form/Messages.svelte";
    import Message from "../form/Message.svelte";
    import AdministrationPeriodTypeDropdown from "../form/AdministrationPeriodTypeDropdown.svelte";
    import StockCalculationStrategyDropdown from "../form/StockCalculationStrategyDropdown.svelte";
    import DialogScreen from "../DialogScreen.svelte";
    import DialogScreenContainer from "../DialogScreenContainer.svelte";
    import ProjectFieldSelectionList from "../participaid/ProjectFieldSelectionList.svelte";
    import ProjectSummary from "../participaid/ProjectSummary.svelte";

    import {Label} from '@smui/button';
    import Icon from '@smui/textfield/icon/index';
    import HelperText from '@smui/textfield/helper-text/index';
    import {Icon as CommonIcon} from '@smui/common';
    import FloatingLabel from '@smui/floating-label';
    import LineRipple from '@smui/line-ripple';
    import NotchedOutline from '@smui/notched-outline';
    import Checkbox from '@smui/checkbox';
    import FormField from '@smui/form-field';
    import Datepicker from "svelte-calendar/src/Components/Datepicker.svelte";
    import Slider from "../form/Slider.svelte";

    const today = new Date();
    const LAST_SCREEN_INDEX = 5;
    const dispatch = createEventDispatcher();
    const randomSlug = () => generateSlug().dashed;
    const defaultSettlementDateTarget = new Date(today.setMonth(today.getMonth()+9));
    const close = () => {
        dispatch("newProject", newProject);
        currentScreenIndex = 0;
        newProject = null;
    }

    // set the upper date limit
    let dateBoundary = new Date();
    dateBoundary.setDate(dateBoundary.getDate() + (365*5));

    export let show;

    // the main form values
    export let name = "";
    export let description = "";
    export let companyId = "";
    export let date = today;
    export let logoUrl = "";
    export let visibilityTeam = true;
    export let companyValuation = 0;
    export let companySharePrice = 0;
    export let companySharePercentage = 100;
    export let stockCalculationStrategy = "DISTRIBUTE_BASED_ON_STOCK_VALUE";
    export let administrationPeriodType = "WEEKLY";
    export let fields = [];

    // passed from Dashboard
    export let companies = [];

    export let currentScreenIndex = 0;

    // mutation request for creating project
    let createRequest;
    let tplFieldsRequest;
    let errorResult;

    // made by submit()
    let newProject;

    $: dialogTitle = (currentScreenIndex < 5) ? "New ParticipAid Partipie " : "Review new project to create ";
    $: dialogTitleEmoji = (currentScreenIndex < 5) ? "rocket" : "mag";

    let titleSuggestion = randomSlug();
    let addOwnerAsContributor = true;

    $: hasCompanies = companies && !!companies.length;
    $: companyIndex = Util.indexBy(companies, "name");
    $: showContributorConfigDialog = !!newProject && addOwnerAsContributor;
    $: selectedCompanyName = companyId && companyIndex[companyId] && companyIndex[companyId].name;
    $: width = (currentScreenIndex != 4) ? 400 : 600;

    /*$: processedFields = fields.map(field => {
        let cloned = {...field};
        delete cloned.__typename;
    });*/

    // a new
    function handleNewCompany(evt) {
        console.log(evt);
        alert("a new company was created!");
        // TODO: set id from evt to id varieble
    }

    function handleExistingCompany(evt) {
        // TODO
    }

    // TODO: this is a workaround
    // the CompanyDropdown _should_ bind company.id
    // values but for some reason doesnt and does company.name instead
    function findCompanyIdByName(nm) {
        for (let company of (companies || [])) {
            if (company.name == nm) {
                return company.id;
            }
        }
        throw `No company found for "${nm}"!`;
    }

    function submit() {
        if (currentScreenIndex < LAST_SCREEN_INDEX) {
            currentScreenIndex = currentScreenIndex + 1;
            return
        }

        if (invalid) {
            console.log(`[NewParticipaidProjectDialog] ignoring submit(): form invalid. Company ID: ${companyId}`);
            return;
        }

        // TODO: turn into computed props
        let cidIsGuid = Util.isGuid(companyId);
        let cid = cidIsGuid ? companyId : findCompanyIdByName(companyId);

        console.log(`Submitting new project dialog... Current Company ID: ${companyId}`);
        console.log(`Company ID is GUID? ${cidIsGuid}`);
        console.log(`Resolved GUID: ${cid}`);

        createRequest = createProject(cid, fields, {
            title: name || randomSlug(),
            avatarUrl: logoUrl,
            description,
            settlementDateTarget: date || defaultSettlementDateTarget,
            visibilityTeam,
            // TODO: expose
            defaultAcceptancePolicy: "MANUAL",
            allowBackTracking: false,
            administrationPeriodType,
            companySharePercentage,
            companySharePrice: companySharePrice * 100,
            companyValuation: companyValuation * 100,
            stockCalculationStrategy
        })

        .then(res => {
            console.log(`Successfully created project!`);
            console.log(res);

            // set reference for when ConfigureContributorDialog
            // finishes
            newProject = res.data.addProject;

            // if we dont have to open a contributor config, close
            // the main dialog. else, setting the project variable will trigger
            // the dependent flag, opening the config
            //if (!addOwnerAsContributor) {
            //    close();
            //}

            // implicitly create default config for project owner.
            // TODO: mention the possibility of configuring this in a Project welcome screen
            return Project.initDefaultOwnerContributor(newProject.id)
                .then(close)
                .catch(err => console.error(err));
        })
        .catch(res => {
            Reporter.error("[NewParticipaidDialog] error trying to create Project", res);
            errorResult = res;
        });
    }

    // set default company id if companies are available
    // TODO: doesnt work because the dropdown sets the selection to nothing
    // when it initializes
    $: if (hasCompanies && !companyId) {
        companyId = companies[0].id;
        console.log(`set default CompanyDropDown id to ${companyId}`)
    }

    $: invalid = (
        (currentScreenIndex == 0 && (!companyId || companyId < 0))
        // || (currentScreenIndex == 4 && (!fields || !fields.length))
    );

</script>

<Dialog {show} request={createRequest} {width}>
    <h1>
        {dialogTitle} <Emoji name={dialogTitleEmoji}/>
    </h1>

    <form>
        <Messages>
            {#if errorResult}
                <Message>{JSON.stringify(errorResult)}</Message>
            {/if}
        </Messages>

        <DialogScreenContainer buttons={false} overflow={currentScreenIndex == 1}>
            {#if currentScreenIndex == 0}
                <DialogScreen>
                    <p>
                        Let's setup your first ParticipAid Partipie <Name/>!
                        Name your project and select the parent company.
                        If no companies have been defined yet, click the button to create your first one!
                    </p>
                    <Field class="field">
                        <TextField
                                bind:value={name}
                                label="Partipie name"
                                style="width: 100%">

                        <span slot="help">
                            Name of your Partipie. Will be generated if left empty. <br/>
                            How about... <a href="#" on:click|preventDefault={() => name = titleSuggestion} style="cursor: pointer;">{titleSuggestion}</a>?
                        </span>
                        </TextField>
                    </Field>
                    <Field class="field">
                        <TextField
                                bind:value={description}
                                label="Partipie description"
                                style="width: 100%">

                        <span slot="help">
                            Description of your Partipie. Will be shown in the dashboard.
                        </span>
                        </TextField>
                    </Field>
                    <Field class="field" outline={!hasCompanies} help="Select parent company for this Partipie">
                        <CompanyDropdownCreator on:new={() => dispatch('newCompany')} {companies} bind:selected={companyId}/>
                    </Field>
                    <Field outline={true} label="Configure Partipie header image. This will be used in the dashboard">
                        <CloudinaryImageUpload
                                bind:url={logoUrl}
                                cropRatio="1.5" />

                        {#if logoUrl}
                            <img src={logoUrl} style="max-height: 100px;"/>
                        {/if}
                    </Field>
                </DialogScreen>
            {/if}

            {#if currentScreenIndex == 1}
                <DialogScreen id="administration-period-screen">
                    <h2>Settlement & Administration</h2>
                    <p>Configure how often you want to perform periodical review and settlement of contributions, here called 'Administration Period'.</p>
                    <Field help="Select administration period duration">
                        <AdministrationPeriodTypeDropdown
                                bind:selectedFieldId={administrationPeriodType}
                        />
                    </Field>
                    <Field outline={true} label="Target settlement date" help="Estimated date that the project will be settled (optional)" >
                        <ul class="target-settlement-shorthands" style="margin: 0; padding: 0; list-style-type: none;">
                            <li>
                                <a href="#" on:click={() => {date = addDate(new Date(), { weeks: 1})}}>...in a week</a>
                            </li>
                            <li>
                                <a href="#" on:click={() => {date = addDate(new Date(), { weeks: 2})}}>...in 2 weeks</a>
                            </li>
                            <li>
                                <a href="#" on:click={() => {date = addDate(new Date(), { weeks: 3})}}>...in 3 weeks</a>
                            </li>
                            <li>
                                <a href="#" on:click={() => {date = addDate(new Date(), { months: 1})}}>...in a month</a>
                            </li>
                            <li>
                                <a href="#" on:click={() => {date = addDate(new Date(), { months: 3})}}>...in 3 months</a>
                            </li>
                            <li>
                                <a href="#" on:click={() => {date = addDate(new Date(), { months: 6})}}>...in 6 months</a>
                            </li>
                            <li>
                                <a href="#" on:click={() => {date = addDate(new Date(), { years: 1})}}>...in a year</a>
                            </li>
                        </ul>
                        <Datepicker
                                start={new Date()}
                                end={dateBoundary}
                                bind:selected={date}
                                format={'#{d}/#{m}/#{Y}'}
                                buttonBackgroundColor='#e20074'
                                buttonTextColor='white'
                                highlightColor='#e20074'
                                dayBackgroundColor='#efefef'
                                dayTextColor='#333'
                                dayHighlightedBackgroundColor='#e20074'
                                dayHighlightedTextColor='#fff'
                        />
                    </Field>
                    <Field class="field">
                        <!--                        <FormField>-->
                        <!--                            <Checkbox bind:checked={addOwnerAsContributor} />-->
                        <!--                            <span slot="label">Add myself as contributor</span>-->
                        <!--                        </FormField>-->
                        <FormField>
                            <Checkbox bind:checked={visibilityTeam} />
                            <span slot="label">Allow team members to see each other's contributions</span>
                        </FormField>
                    </Field>
                </DialogScreen>
            {/if}

            {#if currentScreenIndex == 2}
                <DialogScreen>
                    <h2>Valuation</h2>
                    <p>
                        Configure the value of the company and its shares for this project.
                    </p>

                    <Field class="field">
                        <NumberField
                                bind:value={companySharePrice}
                                label="Company share price"
                                step="0.01"
                                style="width: 100%">
                        </NumberField>
                    </Field>
                    <Field class="field">
                        <NumberField
                                bind:value={companyValuation}
                                label="Company valuation"
                                step="100"
                                style="width: 100%">
                        </NumberField>
                    </Field>
                </DialogScreen>
            {/if}

            {#if currentScreenIndex == 3}
                <DialogScreen>
                    <h2>Stock Distribution</h2>
                    <p>
                        Configure how the stock is distributed.
                    </p>
                    <Field outline={true} label="Part of company shares available ({companySharePercentage}%)" help="Percentage of company shares (existing or issued in the future) that is used for this project">
                        <!--                        <Slider-->
                        <!--                                min={0}-->
                        <!--                                max={100}-->
                        <!--                                bind:value={companySharePercentage}-->
                        <!--                                step={1}-->
                        <!--                                label="Part of company shares available (%)"-->
                        <!--                                help="Percentage of company shares (existing or issued in the future) that is used for this project"-->
                        <!--                        />-->
                        <!--                        <label>Part of company shares available ({companySharePercentage}%)</label>-->
                        <input
                                type="range"
                                min={0}
                                max={100}
                                bind:value={companySharePercentage}
                                step={1}
                                style="width: 100%;"
                                label="Part of company shares available (%)"
                                help="Percentage of company shares (existing or issued in the future) that is used for this project"
                        />
                        <!--                        <small>Percentage of company shares (existing or issued in the future) that is used for this project</small>-->
                    </Field>
                    <Field class="field">
                        <StockCalculationStrategyDropdown
                                bind:selectedFieldId={stockCalculationStrategy}
                                label="Stock calculation strategy"
                                style="width: 100%">
                        </StockCalculationStrategyDropdown>
                    </Field>
                </DialogScreen>
            {/if}

            {#if currentScreenIndex == 4}
                <DialogScreen maxWidth={width}>
                    <p>
                        Configure the fields you would like to use for contributions. This can also be done later.
                    </p>

                    <ProjectFieldSelectionList editable={true} bind:fields />
                </DialogScreen>
            {/if}

            {#if currentScreenIndex == 5}
                <DialogScreen>
                    <ProjectSummary
                        name={name || titleSuggestion}
                        companyName={selectedCompanyName}
                        {visibilityTeam}
                        {administrationPeriodType}
                        endDate={date}
                        {companySharePercentage}
                        {companySharePrice}
                        {companyValuation}
                        {stockCalculationStrategy}
                        {fields}
                    />
                </DialogScreen>
            {/if}
        </DialogScreenContainer>

    </form>

    <div class="action-buttons">
        {#if currentScreenIndex > 0}
            <Button id="button-previous" on:click={() => currentScreenIndex -= 1} variant="outlined">
                <Label>Previous</Label>
            </Button>
        {/if}

        <!-- TODO: validating on name doesnt work -->
        <Button id="button-next" disabled={invalid} on:click={submit} style="float: right;">
            <Label>
                {#if currentScreenIndex < LAST_SCREEN_INDEX}
                    Next
                {:else}
                    View project
                {/if}
            </Label>
        </Button>
    </div>

<!--    {#if createRequest}-->
<!--        {#await createRequest}-->
<!--            <LoadingModal global={false}/>-->
<!--        {/await}-->
<!--    {/if}-->
</Dialog>

{#if newProject}
<!--    <Overlay show={showContributorConfigDialog} closable={true} background="darken" loaderBackground={false} on:close={close}>-->
<!--        <ConfigureContributorDialog-->
<!--                projectId={newProject.id}-->
<!--                isSelf={true}-->
<!--                isOwner={true}-->
<!--                on:new={close}-->
<!--        />-->
<!--    </Overlay>-->
{/if}

<style>
    form {
        margin: 25px 0;
    }

    .field {
        margin-bottom: 25px;
    }

    p {
        text-align: center;
        margin: 25px 0;
    }

    .review-field-name {
        font-weight: bold;
    }

    .target-settlement-shorthands li {
        display: inline-block;
        padding: 4px;
        background: #eee;
        font-size: 13px;
        margin-bottom: 10px;
        font-weight: bold;
    }

    :global(#button-next) {
        margin: auto;
        //margin-top: 50px;
        display: inherit;
    }

    :global(#administration-period-screen .sc-popover .contents-wrapper) {
        transform: translate(-50%, -80%) translate(0px, 0px) !important;
    }
</style>